var render = function render(){var _vm=this,_c=_vm._self._c;return _c('confirm',{ref:"confirmDialog",attrs:{"confirmText":_vm.$t('dialogs-confirm.buttons.remove'),"confirmColor":"red darken-1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }